import { Facet } from '../../../models/Facet';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';

/**
 * Special column representing custom fields backed by the schema for a given item set.
 */
export const fieldsColumn: IColumn = {
  key: new Facet('fieldsColumn').id,
  name: 'Fields',
  fieldName: '',
  minWidth: 0
};
